if (!window.CartProgressBarComponent) {
  const CartProgressBarComponent = {
    props: {
      minimumFreeShipping: {
        type: Number,
        required: true,
      },
      cartFreeText: {
        type: String,
        required: true,
      },
      cartCalculateText: {
        type: String,
      },
    },
    template: `
      <div v-if="hasItems && !isQualified && isUK">
        <div>
          <p class="title-style1 mb-1 text-sm text-black">
            {{ formatMessage(translations.missing_amount, formatPrice(missingAmount)) }}
          </p>
        </div>

        <div class="progress-bar-container w-full bg-pink-100 rounded-full h-1 overflow-hidden relative mt-2">
          <div
            class="progress-bar absolute left-0 top-0 h-full rounded-full bg-gradient-to-r from-background-brand-primary-dark to-background-brand-primary transition-all duration-300 ease-out"
            :style="{ width: progressPercentage + '%' }"
            role="progressbar"
            :aria-valuenow="progressPercentage"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <div class="flex justify-between text-xs text-tertiary title-style1 mt-1">
          <span>{{ formatPrice(0) }}</span>
          <span>{{ formatPrice(threshold) }}</span>
        </div>
      </div>
    `,
    data() {
      return {
        translations: window.cartProgressTranslations || {},
        countryCode: null,
      };
    },
    computed: {
      threshold() {
        return this.minimumFreeShipping * 100;
      },
      isUK() {
        return (
          store.state.location === "GB" ||
          !store.state.location
        );
      },
      hasItems() {
        return store.state.cart?.items?.length > 0;
      },
      cartTotal() {
        return store.state.cart?.total_price || 0;
      },
      progressPercentage() {
        const percentage = (this.cartTotal / this.threshold) * 100;
        return Math.min(100, Math.max(0, percentage));
      },
      isQualified() {
        return this.cartTotal >= this.threshold;
      },
      missingAmount() {
        return this.threshold - this.cartTotal;
      },
      isFreeDelivery() {
        return this.isQualified && this.isUK;
      },
    },
    methods: {
      formatPrice(cents) {
        return formatCurrency(Shopify.currency.active, cents);
      },
      formatMessage(template, value) {
        if (!template) return "";
        return template.replace("%s", value);
      },
    },
    watch: {
      isFreeDelivery: {
        handler(newValue) {
          const el = document.getElementById("delivery-estimate");
          if (el)
            el.innerHTML = newValue ? this.cartFreeText : this.cartCalculateText;
        },
        immediate: true,
      },
    },
  };

  // Export the component to be used in other Vue apps
  window.CartProgressBarComponent = CartProgressBarComponent;
}
